
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { SocialLinks } from "@/components/SocialLinks";
import { useNavConfig } from "@/hooks/useNavConfig";
import { useSiteLogo } from "@/hooks/useSiteLogo";

export function Footer() {
  const { footerSections, isNavItemVisible } = useNavConfig();
  const logoUrl = useSiteLogo();

  return (
    <footer className="bg-gray-900 text-gray-400 py-16">
      <div className="container mx-auto px-6">
        {/* Logo & tagline */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-12 pb-10 border-b border-gray-800 gap-6">
          <div className="flex items-center gap-3">
            {logoUrl ? (
              <img src={logoUrl} alt="Logo" className="w-12 h-12 rounded-2xl object-cover shadow-lg" />
            ) : (
              <div className="w-12 h-12 bg-brand-primary rounded-2xl flex items-center justify-center text-white text-2xl shadow-lg">
                ⚜️
              </div>
            )}
            <div>
              <p className="text-white font-extrabold text-lg leading-tight font-primary">Clínica de Nutrição Equilíbrio</p>
              <p className="text-gray-400 text-sm font-primary">Dra. Brenda Ramos · CRN/3-63492</p>
            </div>
          </div>
          <p className="title-special text-xl text-brand-softOrange max-w-sm">
            Cuidar com ciência, ouvir com empatia & nutrir com equilíbrio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Dynamic sections */}
          {footerSections.map(section => {
            const visibleItems = section.items.filter(isNavItemVisible);
            return (
              <div key={section.id}>
                <h3 className="text-lg font-semibold text-white mb-4">{section.title}</h3>
                <ul className="space-y-2">
                  {visibleItems.map(item => (
                    <li key={item.id}>
                      <Link to={item.path} className="text-gray-300 hover:text-brand-primary transition-colors">
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}

          {/* CONSULTÓRIOS — always static */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">CONSULTÓRIOS</h3>
            <ul className="space-y-2">
              {[
                { label: "Av. Paulista",          to: "/consultorios" },
                { label: "Cidade Mogi das Cruzes", to: "/consultorios" },
                { label: "Cidade Suzano",          to: "/consultorios" },
              ].map(loc => (
                <li key={loc.label}>
                  <Link to={loc.to} className="text-gray-300 hover:text-brand-primary transition-colors flex items-center">
                    <MapPin className="w-4 h-4 mr-2" />
                    {loc.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* REDES SOCIAIS — always static */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">ME SIGA NAS REDES</h3>
            <SocialLinks />
          </div>
        </div>

        {/* Direitos Reservados */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-300 mb-2 text-sm sm:text-base">
            © 2026 Dra Brenda Ramos - Nutricionista responsável CRN: 3/63492 | CNPJ: 55.373.902/0001-65
          </p>
          <p className="text-gray-400 text-xs sm:text-sm">
            Desenvolvimento por{" "}
            <a
              href="https://www.finalogica.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-primary hover:text-brand-secondary transition-colors"
            >
              Finalógica Soluções
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
